import { ref } from "vue";
import { defineStore } from "pinia";
import UserService from "@/core/services/UserService";
import JwtService from "@/core/services/JwtService";
import { UserInfoDto } from "@/core/services/ApiClient";
import { hasJwtToken } from "@/core/helpers/auth-token";

export const useAuthStore = defineStore("auth", () => {
    const errors = ref({});
    const user = ref<UserInfoDto>(UserService.getUser() || {} as UserInfoDto);
    const token = ref<string>(JwtService.getToken() || '');
    const isAuthenticated = ref(hasJwtToken(JwtService.getToken()));
    function setAuth(newToken: string, authUser: UserInfoDto) {
        user.value = authUser;
        errors.value = {};
        token.value = newToken;
        if (!hasJwtToken(newToken)) {
            isAuthenticated.value = false;
            return;
        }
        isAuthenticated.value = true;
        JwtService.saveToken(newToken);
        UserService.saveUser(user.value);
    }

    function setUserInfo( authUser: UserInfoDto) {
        user.value = authUser;
        UserService.saveUser(user.value);
    }
    function purgeAuth() {
        isAuthenticated.value = false;
        user.value = {} as UserInfoDto;
        token.value = "";
        errors.value = [];
        JwtService.destroyToken();
        UserService.destroyUser();
    }

    function rehydrateFromStorage() {
        const savedToken = JwtService.getToken();
        if (!hasJwtToken(savedToken)) {
            if (savedToken) {
                JwtService.destroyToken();
                UserService.destroyUser();
            }
            isAuthenticated.value = false;
            token.value = "";
            user.value = {} as UserInfoDto;
            return;
        }
        const savedUser = UserService.getUser();
        token.value = savedToken!;
        user.value = savedUser || ({} as UserInfoDto);
        isAuthenticated.value = true;
    }

    function login(token: string, user: UserInfoDto) {
        setAuth(token, user);
    }

    function logout() {
        purgeAuth();
    }

    return {
        errors,
        user,
        token,
        isAuthenticated,
        login,
        logout,
        setUserInfo,
        rehydrateFromStorage,
    };
});
